<div class="chat-container">
  <!-- Floating Model Selector -->
  <app-chat-header
    class="chat-header"
    [title]="state.assistant.name!"
    [chatType]="state.chatType"
    [modelSelector]="state.modelSelectorEnabled$ | async"
    (modelSelected)="onModelSelected($event)"
  ></app-chat-header>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>

  <!-- Messages Area -->
  <div class="chat-messages-container" #scrollContainer>
    <app-chat-messages
      [messages]="(messages$ | async) || []"
      [welcomeMessage]="state.assistant.welcome_message!"
    ></app-chat-messages>
  </div>

  <!-- Floating Scroll-to-Bottom Button -->
  <app-chat-scroll-button 
    [visible]="showScrollButton && !loading"
    (scrollClick)="onScrollToBottom()"
  ></app-chat-scroll-button>

  <!-- Chat input component -->
  <app-chat-input
    class="chat-input-container"
    (sendMessage)="sendMessageStream($event)"
  ></app-chat-input>
</div>
